import { render, staticRenderFns } from "./LastUpgrade.vue?vue&type=template&id=6b7b1b44&"
import script from "./LastUpgrade.vue?vue&type=script&lang=ts&"
export * from "./LastUpgrade.vue?vue&type=script&lang=ts&"
import style0 from "./LastUpgrade.vue?vue&type=style&index=0&id=6b7b1b44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports